module.exports = __webpack_public_path__ + "static/media/report.6cbc28f3.svg";